import formStyle from "~/Screens/GeneralStyles/formStyle";

const useStyles = (theme) => ({
    ...formStyle(theme),
});


export default useStyles;